import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Navigation = () => {
  const location = useLocation();
  const [isRecording, setIsRecording] = useState(false);
  
  const isActive = (path) => location.pathname === path;

  // Listen for recording state changes
  useEffect(() => {
    const checkRecordingState = () => {
      setIsRecording(!!window.isRecordingInProgress);
    };

    // Check initially
    checkRecordingState();

    // Set up interval to check recording state
    const interval = setInterval(checkRecordingState, 100);

    return () => clearInterval(interval);
  }, []);

  const handleNavClick = (e, path) => {
    // Block navigation if recording is in progress
    if (isRecording) {
      e.preventDefault();
      return;
    }
  };
  
  return (
    <nav className="bg-deepspace-surface border-b border-deepspace-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <h1 className="text-xl font-bold font-outfit text-[#EDEDED]">
                Tab Audio Transcriber
              </h1>
            </div>
            <div className="ml-10 flex items-baseline space-x-4">
              <Link
                to="/"
                onClick={(e) => handleNavClick(e, '/')}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                  isActive("/")
                    ? "bg-volt-blue text-white"
                    : "text-[#A1A1AA] hover:bg-deepspace-surfaceHighlight hover:text-[#EDEDED]"
                } ${isRecording && !isActive("/") ? "opacity-40 cursor-not-allowed pointer-events-none" : ""}`}
                data-testid="admin-console-link"
              >
                Admin Console
              </Link>
              <Link
                to="/recording"
                onClick={(e) => handleNavClick(e, '/recording')}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                  isActive("/recording")
                    ? "bg-volt-blue text-white"
                    : "text-[#A1A1AA] hover:bg-deepspace-surfaceHighlight hover:text-[#EDEDED]"
                } ${isRecording && !isActive("/recording") ? "opacity-40 cursor-not-allowed pointer-events-none" : ""}`}
                data-testid="recording-console-link"
              >
                Recording Console
              </Link>
              <Link
                to="/realtime"
                onClick={(e) => handleNavClick(e, '/realtime')}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                  isActive("/realtime")
                    ? "bg-volt-blue text-white"
                    : "text-[#A1A1AA] hover:bg-deepspace-surfaceHighlight hover:text-[#EDEDED]"
                } ${isRecording && !isActive("/realtime") ? "opacity-40 cursor-not-allowed pointer-events-none" : ""}`}
                data-testid="realtime-console-link"
              >
                Realtime Console
              </Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
